import { useSelector } from 'react-redux';
import {
  getEngagementUrl,
  getDPReportUrl,
} from '../../features/project/projectSlice';

const usePowerBiUrl = () => {
  const engagementUrl = useSelector(getEngagementUrl);
  const DPReportUrl = useSelector(getDPReportUrl);

  return DPReportUrl || `${engagementUrl}/reports`;
};

export default usePowerBiUrl;
